<div class="key-viewer">
    <nuc-input class="key-input" [disabled]="true" type="{{!viewKey ? 'password' : 'text'}}" [data]="key"></nuc-input>
    <nuc-button-secondary icon="nucicon_eye" [nucTooltip]="viewKey ? 'Hide' : 'Reveal'" (click)="toggleVisibility()"
                          [disabled]="disabled"></nuc-button-secondary>
    <nuc-button-secondary icon="nucicon_duplicate" nucTooltip="Copy" (click)="copyKey()"
                          [disabled]="disabled"></nuc-button-secondary>
</div>
